import { JSX } from 'react';

import loadable from '~/components/utils/lazyImport';

// Core pages
export const IndexPage = loadable(() => import(/* webpackChunkName: "IndexPage" */ './IndexPage'));

// Offers pages
export const OffersPage = loadable(() => import(/* webpackChunkName: "OffersPage" */ './Offers/Home/OffersPage'));
export const OfferDetailContainer = loadable(
  () => import(/* webpackChunkName: "OfferDetail" */ './Offers/Detail/OfferDetailContainer'),
);
export const OfferEditContainer = loadable(
  () => import(/* webpackChunkName: "OfferEdit" */ './Offers/Edit/OfferEditContainer'),
);
export const ImagesEditContainer = loadable(
  () => import(/* webpackChunkName: "ImagesEdit" */ './Offers/Edit/ImagesEditContainer'),
);
export const VideosEditContainer = loadable(
  () => import(/* webpackChunkName: "VideosEdit" */ './Offers/Edit/VideosEditContainer'),
);
export const PackagesEditContainer = loadable(
  () => import(/* webpackChunkName: "PackagesEdit" */ './Offers/Edit/PackagesEditContainer'),
);
export const StructuredFinePrintPage = loadable(
  () => import(/* webpackChunkName: "StructuredFinePrint" */ './Offers/Edit/StructuredFinePrintPage'),
);
export const StructuredFacilitiesPage = loadable(
  () => import(/* webpackChunkName: "StructuredFacilities" */ './Offers/Edit/StructuredFacilitiesPage'),
);

// Custom Offers pages
export const CustomOffersCreatePage = loadable(
  () => import(/* webpackChunkName: "CustomOffersCreate" */ '../pages/CustomOffers/Create'),
);
export const CustomOffersEditPage = loadable(
  () => import(/* webpackChunkName: "CustomOffersEdit" */ '../pages/CustomOffers/Edit'),
);

// Site Banner Campaigns
export const SiteBannerCampaignsPage = loadable(
  () => import(/* webpackChunkName: "SiteBannerCampaigns" */ './Content/SiteBanners/SiteBannerCampaignsPage'),
);
export const SiteBannerCampaignCreate = loadable(
  () => import(/* webpackChunkName: "SiteBannerCampaignCreate" */ './Content/SiteBanners/SiteBannerCampaignCreate'),
);
export const SiteBannerCampaignEdit = loadable(
  () =>
    import(/* webpackChunkName: "SiteBannerCampaignEdit" */ './Content/SiteBanners/SiteBannerCampaignEditContainer'),
);

// LE Lab
export const LabPage = loadable(() => import(/* webpackChunkName: "LabPage" */ './LELab/LabPage'));

// OpenAI Proxy
export const OpenAIPage = loadable(() => import(/* webpackChunkName: "OpenAIPage" */ '../pages/OpenAI/Page'));

// LE Data chat
export const LeDataPage = loadable(
  () => import(/* webpackChunkName: "LeDataPage" */ '../pages/DataChatbot/LeDataPage'),
);
export const SalesPerformanceDashboardPage = loadable(
  () =>
    import(
      /* webpackChunkName: "SalesPerformanceDashboardPage" */ '../pages/SalesPerformanceDashboard/SalesPerformanceDashboardPage'
    ),
);
// BriefCase
export const BriefCasePage = loadable(() => import(/* webpackChunkName: "BriefCasePage" */ '../pages/BriefCase/Page'));
export const BriefCaseTemplatePage = loadable(
  () => import(/* webpackChunkName: "BriefCaseTemplatePage" */ '../pages/BriefCaseTemplate/Page'),
);

// Purchases pages
export const PurchasesPageContainer = loadable(
  () => import(/* webpackChunkName: "PurchasesPage" */ './Purchases/Home/PurchasesPageContainer'),
);
export const OrderDetailContainer = loadable(
  () => import(/* webpackChunkName: "OrderDetail" */ './Purchases/OrderDetail/OrderDetailContainer'),
);
export const OrderFinancialRecordsPage = loadable(
  () =>
    import(
      /* webpackChunkName: "OrderFinancialRecords" */ './Purchases/OrderFinancialRecords/OrderFinancialRecordsPage'
    ),
);

// Users pages
export const UsersPageContainer = loadable(
  () => import(/* webpackChunkName: "UsersPage" */ './Users/UsersPageContainer'),
);
export const AgenciesPage = loadable(() => import(/* webpackChunkName: "AgenciesPage" */ './Users/AgenciesPage'));
export const UserPage = loadable(() => import(/* webpackChunkName: "UserPage" */ './Users/UserPage'));

// Vendors pages
export const VendorsPageContainer = loadable(
  () => import(/* webpackChunkName: "VendorsPage" */ './Vendors/Home/VendorsPageContainer'),
);
export const VendorsDetailContainer = loadable(
  () => import(/* webpackChunkName: "VendorDetail" */ './Vendors/Profile/VendorsDetailContainer'),
);

// System pages
export const SystemPageContainer = loadable(
  () => import(/* webpackChunkName: "SystemPage" */ './System/SystemPageContainer'),
);
export const AdminUsersPageContainer = loadable(
  () => import(/* webpackChunkName: "AdminUsersPage" */ './System/AdminUsersPageContainer'),
);
export const StoplistPage = loadable(() => import(/* webpackChunkName: "StoplistPage" */ './Stoplist/StoplistPage'));
export const AccountDeletionsPage = loadable(
  () => import(/* webpackChunkName: "AccountDeletionsPage" */ './AccountDeletions/pages/Home/AccountDeletionsPage'),
);
export const ReservationRemediation = loadable(
  () =>
    import(/* webpackChunkName: "ReservationRemediation" */ './System/ReservationRemediation/ReservationRemediation'),
);
export const AuditLogSearch = loadable(
  () => import(/* webpackChunkName: "AuditLogSearch" */ './System/AuditLogSearch'),
);
export const PermissionsContainer = loadable(
  () => import(/* webpackChunkName: "PermissionsContainer" */ './System/PermissionsContainer'),
);
export const Settings = loadable(() => import(/* webpackChunkName: "Settings" */ './System/Settings/Settings'));
export const EmailAIKillSwitchesPage = loadable(
  () =>
    import(/* webpackChunkName: "EmailAIKillSwitchesPage" */ './System/EmailAIKillSwitches/EmailAIKillSwitchesPage'),
);
export const ImageUploaderUtilityPage = loadable(
  () => import(/* webpackChunkName: "ImageUploaderUtilityPage" */ './System/ImageUploader/ImageUploaderUtilityPage'),
);
export const AIImageManagerPage = loadable(
  () => import(/* webpackChunkName: "AIImageManagerPage" */ './System/AIImageManager/AIImageManagerPage'),
);
export const SalesFxHedging = loadable(
  () => import(/* webpackChunkName: "SalesFxHedging" */ './System/SalesFxHedging/SalesFxHedgingPage'),
);
export const TrainingAccountProvisioningPage = loadable(
  () =>
    import(
      /* webpackChunkName: "TrainingAccountProvisioningPage" */ './System/TrainingAccountProvisioning/TrainingAccountProvisioningPage'
    ),
);
export const CSNewHireQuizPage = loadable(
  () => import(/* webpackChunkName: "CSNewHireQuizPage" */ './System/CSNewHireQuiz/CSNewHireQuizPage'),
);
export const SystemUserPage = loadable(
  () => import(/* webpackChunkName: "SystemUserPage" */ './System/SystemUserPage'),
);
export const FindSimilarAccountsPage = loadable(
  () =>
    import(/* webpackChunkName: "FindSimilarAccountsPage" */ './System/FindSimilarAccounts/FindSimilarAccountsPage'),
);
export const BulkCreditAllocationPage = loadable(
  () =>
    import(/* webpackChunkName: "BulkCreditAllocationPage" */ './System/BulkCreditAllocation/BulkCreditAllocationPage'),
);
export const BulkVccReplacementPage = loadable(
  () => import(/* webpackChunkName: "BulkVccReplacementPage" */ './System/BulkVccReplacement/BulkVccReplacementPage'),
);
export const CreditReversalsPage = loadable(
  () => import(/* webpackChunkName: "CreditReversalsPage" */ './System/CreditReversals/CreditReversalsPage'),
);
export const SaleOwnershipSwapsPage = loadable(
  () => import(/* webpackChunkName: "SaleOwnershipSwapsPage" */ './System/SaleOwnershipSwaps/SaleOwnershipSwapsPage'),
);
export const CogsAdjustmentRequestsPage = loadable(
  () =>
    import(
      /* webpackChunkName: "CogsAdjustmentRequestsPage" */ './System/CogsAdjustmentRequests/CogsAdjustmentRequestsPage'
    ),
);
export const EmailDeliveryFailuresPage = loadable(
  () =>
    import(
      /* webpackChunkName: "EmailDeliveryFailuresPage" */ './System/EmailDeliveryFailures/EmailDeliveryFailuresPage'
    ),
);
export const CSAnalysisPage = loadable(
  () => import(/* webpackChunkName: "CSAnalysisPage" */ './System/CSAnalysis/CSAnalysisPage'),
);

// Customer Communication pages
export const BannerUploadPage = loadable(
  () => import(/* webpackChunkName: "BannerUploadPage" */ './CustomerCommunication/BannerUpload/BannerUploadPage'),
);

// Tours pages
export const ToursLEListPage = loadable(
  () => import(/* webpackChunkName: "ToursLEList" */ './Tours/Pages/Lists/ToursLEListPage'),
);
export const ToursTTCListPage = loadable(
  () => import(/* webpackChunkName: "ToursTTCList" */ './Tours/Pages/Lists/ToursTTCListPage'),
);
export const ToursDepartureInsightsPage = loadable(
  () => import(/* webpackChunkName: "ToursDepartureInsights" */ './Tours/Pages/Lists/ToursDepartureInsightsPage'),
);
export const ToursManifestPage = loadable(
  () => import(/* webpackChunkName: "ToursManifest" */ './Tours/Pages/Lists/ToursManifestPage'),
);
export const ToursNotificationsPage = loadable(
  () => import(/* webpackChunkName: "ToursNotifications" */ './Tours/Pages/Lists/ToursNotificationsPage'),
);

// Other feature pages
export const FlightsPage = loadable(
  () => import(/* webpackChunkName: "FlightsPage" */ './Flights/FlightsPageContainer'),
);
export const ExperiencesPage = loadable(() => import(/* webpackChunkName: "ExperiencesPage" */ './Experiences'));
export const TripPlannerPage = loadable(
  () => import(/* webpackChunkName: "TripPlannerPage" */ './TripPlanner/TripPlannerPage'),
);

export const PromoDetailContainerV3 = loadable<JSX.Element>(
  () => import(/* webpackChunkName: "PromoDetailContainerV3" */ './PromoV3/PromoDetailContainerV3'),
);
